interface Props {
  messages: string[];
}
export function Alert({ messages }: Props) {
  return (
    <>
      <div className="alert alert-danger alert-dismissible fade show">
        {messages.map((msg, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: msg }} />
        ))}
        {/* <button type="button" className="btn-close" data-bs-dismiss="alert" /> */}
      </div>
    </>
  );
}

{
  /* <div className="alert alert-danger alert-dismissible fade show">
  <div>* 한번 등록한 장소 정보의 주소는 수정이 불가능합니다.</div>
  <div>* 이미지 편집 시 실시간으로 처리됩니다. 삭제에 주의하세요.</div>
</div>; */
}
